import React, { Component } from 'react';
import _ from 'lodash';

import UrbioticaSensorsTable from '../components/UrbioticaSensorsTable';
import UrbioticaParkinglocationsSelect from '../components/UrbioticaParkinglocationsSelect';
import UrbioticaSensorsForm from '../components/UrbioticaSensorsForm';

import UrbioticaSensorsModel from '../components/UrbioticaSensorsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, message } from 'antd';

class UrbioticaSensorsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: false,
    dataAll: [],
    data: [],
    searchedTextValue: "",
    urbioticaSensorsFormModalVisible: false,
    urbioticaParkinglocationId: null
  }

  intervalId = null;

  componentWillMount() {
    this.loadData(this.state.urbioticaParkinglocationId);

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload && this.state.urbioticaParkinglocationId) {
        this.loadData(this.state.urbioticaParkinglocationId);
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData(urbioticaParkinglocationId) {
    this.setState({
      dataLoading: true
    });
    UrbioticaSensorsModel.getAll(urbioticaParkinglocationId)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.');
        this.setState({
          dataLoading: false,
        });
      });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Urbiotica - Senzory</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={16}>
                <UrbioticaParkinglocationsSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(value);
                    this.setState({ searchedTextValue: "", urbioticaParkinglocationId: value });
                  }}
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Najít seriové číslo"
                  value={this.state.searchedTextValue}
                  onSearch={(searchText) => {
                    const dataAll = this.state.dataAll;
                    this.setState({
                      data: _.filter(dataAll, (d) => {
                        return d.urbioticaID.toString().startsWith(searchText);
                      })
                    });
                  }}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.urbioticaParkinglocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'URBIOTICA_SENSORS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ urbioticaSensorsFormModalVisible: true }) }}>Nový senzor</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <UrbioticaSensorsForm
            type="modal"
            modalVisible={this.state.urbioticaSensorsFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ urbioticaSensorsFormModalVisible: false })
            }}
            onSuccess={(form, values) => {
              UrbioticaSensorsModel.create(values)
                .then(() => {
                  form.resetFields(['urbioticaID', 'placeID']);
                  this.loadData(this.state.urbioticaParkinglocationId);
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <UrbioticaSensorsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onAnyFormSuccess={() => {
              this.loadData(this.state.urbioticaParkinglocationId);
            }}
            onRemoveRow={(id) => {
              UrbioticaSensorsModel.remove(id)
                .then(() => {
                  this.loadData(this.state.urbioticaParkinglocationId);
                })
                .catch((err) => {
                  message.warning('Senzor se nepodařilo smazat. Prosím kontaktujte správce systému!');
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default UrbioticaSensorsScreen;



// WEBPACK FOOTER //
// ./src/screens/UrbioticaSensorsScreen.js